import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Row, Col } from 'react-flexbox-grid'
import { FormGroup, ControlLabel } from 'react-bootstrap'

import { GlgSelect } from 'SharedComponents'
import RegistrationFilterTypes from '../../../registration_filter_types'

const RegistrationFilter = ({ value, onChange, showRegistrationOptions, disabled }) => {
  const [searchValue, setSearchValue] = useState(value)

  const filterEventsText = (!window.I18n ? '' : window.I18n.t('customer_center_filters.components.filters.registration_filter.filter_events'))
  let options = _.clone(OPTIONS)
  if (!showRegistrationOptions) {
    options = options.filter(option => (
      !REGISTRATION_OPTIONS_VALUES.includes(option.value)
    ))
  }

  options = options.map(option => ({
    ...option,
    label: window.I18n.t(`customer_center_filters.components.filters.registration_filter.options.${ option.value }`, { defaultValue: option.label }),
  }))

  useEffect(() => {
    onChange('registration', searchValue)
  }, [searchValue, onChange])

  useEffect(() => {
    setSearchValue(value)
  }, [value])

  const handleChange = (event) => {
    const value = event
    setSearchValue(value)
  }

  return (
    <FormGroup>
      <Row>
        <Col xs={ true }>
          <ControlLabel className='filter_label' id='filter_label'>
            { filterEventsText }
          </ControlLabel>
        </Col>
      </Row>
      <Row>
        <Col xs={ true }>
          <GlgSelect
            items={ options }
            value={ searchValue }
            onChange={ handleChange }
            disabled={ disabled }
          />
        </Col>
      </Row>
    </FormGroup>
  )
}

RegistrationFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  showRegistrationOptions: PropTypes.bool,
}

const OPTIONS = [
  {
    value: RegistrationFilterTypes.ALL,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.all'),
  },
  {
    value: RegistrationFilterTypes.UPCOMING,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.upcoming'),
  },
  {
    value: RegistrationFilterTypes.PAST,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.past'),
  },
  {
    value: RegistrationFilterTypes.OPEN,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.registration_open'),
  },
  {
    value: RegistrationFilterTypes.WILL_OPEN,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.registration_will_open'),
  },
  {
    value: RegistrationFilterTypes.OPEN_FOR_INVITATION,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.registration_open_invitation_list'),
  },
  {
    value: RegistrationFilterTypes.OPEN_FOR_MEMBERSHIP,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.registration_open_membership'),
  },
  {
    value: RegistrationFilterTypes.CLOSED,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.registration_closed'),
  },
  {
    value: RegistrationFilterTypes.WAITLIST_NOT_EMPTY,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.waitlist'),
  },
  {
    value: RegistrationFilterTypes.PENDING_LIST_NOT_EMPTY,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.pending_registration'),
  },
  {
    value: RegistrationFilterTypes.NON_ARCHIVED,
    label: window.I18n.t('customer_center_comp.components.sim_golf_labels.all_except_archived'),
  },
]

const REGISTRATION_OPTIONS_VALUES = [
  RegistrationFilterTypes.OPEN,
  RegistrationFilterTypes.WILL_OPEN,
  RegistrationFilterTypes.OPEN_FOR_INVITATION,
  RegistrationFilterTypes.OPEN_FOR_MEMBERSHIP,
  RegistrationFilterTypes.CLOSED,
  RegistrationFilterTypes.WAITLIST_NOT_EMPTY,
  RegistrationFilterTypes.PENDING_LIST_NOT_EMPTY,
]

export default RegistrationFilter